import React from 'react';
import { useImport } from '../context/ImportContext';

const ImportBanner = () => {
  const { isActive, total, processed, failed, hidden, hideBanner } = useImport();

  if (hidden || (!isActive && processed === 0)) return null;

  const pct = total ? Math.min(100, Math.round((processed / total) * 100)) : 0;

  return (
    <div
      className="fixed right-2 z-[70]
                 bottom-[calc(env(safe-area-inset-bottom,0px)+72px)]
                 md:bottom-3"
    >
      <div className="rounded-2xl border border-gray-200 bg-white/90 backdrop-blur shadow-[0_12px_40px_rgba(16,24,40,0.15)] px-4 py-3">
        <div className="flex items-center justify-between gap-3">
          <div className="min-w-0">
            <p className="text-sm font-medium text-gray-900 truncate">
              Ajout en arrière-plan
            </p>
            <p className="text-xs text-gray-600 truncate">
              {processed < total ? `Import des vêtements… ${processed}/${total}` : `Import terminé (${total - failed} ajoutés${failed ? `, ${failed} échec(s)` : ''})`}
            </p>
          </div>
          <button onClick={hideBanner} className="text-xs text-gray-500 hover:text-gray-700">Masquer</button>
        </div>
        <div className="mt-2 h-2 bg-gray-200 rounded-full overflow-hidden">
          <div className="h-full bg-black transition-all" style={{ width: `${pct}%` }} />
        </div>
      </div>
    </div>
  );
};

export default ImportBanner;
